import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoadingPanelService {
    public loadingPanelShowSubscriber = new Subject<LoadingPanelSettings>();
    public loadingPanelHideSubscriber = new Subject<void>();

    public showLoadingPanelDirect(loadingText: string) {
        this.loadingPanelShowSubscriber.next(new LoadingPanelSettings(loadingText));
    }

    public showLoadingPanel(settings: LoadingPanelSettings) {
        this.loadingPanelShowSubscriber.next(settings);
    }

    public hideLoadingPanel() {
        this.loadingPanelHideSubscriber.next();
    }
}

export class LoadingPanelSettings {
    constructor(public message: string, public modal: boolean = true) { }
}
